/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-11-16 18:06:31
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-18 10:32:54
 */
import {
  AlipayCircleFilled,
  CreditCardFilled,
  DollarCircleFilled,
  ExclamationCircleFilled,
  WechatFilled,
} from '@ant-design/icons'
import { current, unwrapResult } from '@reduxjs/toolkit'
import {
  Col,
  message,
  Modal,
  notification,
  Row,
  Space,
  Table,
  Tooltip,
} from 'antd'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectInsuranceArray,
  selectUserName,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantName,
  selectTenantCategory,
  selectUserId,
  selectEdition,
} from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import {
  selectInsuranceItem,
  setInsurance,
} from '../../../layouts/insuranceSlice'
import { traceRoute } from '../../../layouts/layoutSlice'
import { DateTimeFormatSimpleOnlyOne } from '../../../models/datetime'
import { Payment, PaymentStatus } from '../../../models/payment'
import { RecipeStatus } from '../../../models/recipe'
import { Refund } from '../../../models/refund'
import { PaymentListParams } from '../../../services/payment'
import { ThemeContext } from '../../../theme/ThemeContext'
import {
  strParse,
  medicalSendHttp,
  readCardSHttp,
  getTradeName,
  readCardEHttp,
} from '../../../utils/MedicalUtils'
import {
  cancelSettlementAsync,
  saveSettlementAsync,
  selfPayUploadAsync,
  selfPayRepealAsync,
  preSettlementAsync,
  pay,
  FeeListUpAsync,
  FeeListUpCancelAsync,
  setUpdateFlagsAsync,
  updateCardInfoAsync,
  payAgainAsync,
} from '../confirm/paymentConfirmSlice'
import {
  removeSale3507AAsync,
} from '../../putstorage/putstorageSlice'
import {
  cancelSaleUpload,
  getPaymentResult,
  isCancelUpload,
  selectResult,
} from '../result/paymentResultSlice'
import { AGColumns, PaymentColumns, PaymentColumnsWithAmount } from './columns'
import {
  getPaymentDetail,
  getPaymentList,
  refund as refundPayment,
  selectPaymentPage,
  JuhePremium,
  getAllDepartmentUser,
  getPaymentListExoprt,
  getCheckHistoryAsync,
} from './paymentSlice'
import { PaymentQuery } from './Query'
import { serverType } from '../../../services/commodity'
import { PaymentConfirm, PaymentConfirmRef } from '../confirm/PaymentConfirm'
import { PaymentConfirmation } from '../../../models/confirmation'
import {
  getPatientInfoAsync,
  registerValue,
} from '../../registration/register/registerSlice'
import { JuhePay } from '../../../compnents/icons/Icons'
import styles from './Payments.module.css'
import { RealPayModal } from './realPayModal'
import { TableRowSelection } from 'antd/lib/table/interface'
import { DataType } from '../../putstorage/putstorage'
import { sum } from 'lodash'
import { getTradeCode } from '../../../models/material'
import { DetailModalList } from './modalDetailList'
import { ChargeAgainModal } from './chargeAgainModal'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../../transactionQuery/transactionQuerySlice'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../../models/common'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'

export interface PaymentsRef {
  reload: () => void
}

interface PaymentProps {
  selectedTab?: any
  status: PaymentStatus
  sibling?: PaymentsRef | null
  YBZFUploadflag?: boolean
  LSCFSHflag?: boolean
}

const RealPayments = (
  {
    selectedTab,
    status,
    sibling = null,
    YBZFUploadflag = false,
    LSCFSHflag = false,
  }: PaymentProps,
  ref: React.Ref<PaymentsRef>
): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const refModal = useRef<PaymentConfirmRef>(null)

  const [confirmation, setConfirmation] = useState<
    PaymentConfirmation | undefined
  >(undefined)

  const [registerData, setRegisterData] = useState<registerValue | undefined>()

  const [buttonLoading, setButtonLoading] = useState(false)

  const [auditButtonLoading, setAuditButtonLoading] = useState<any>()

  const [auditAllButtonLoading, setAuditAllButtonLoading] = useState<any>()

  const [stkButtonLoading, setStkButtonLoading] = useState(false)

  const [ybFaceButtonLoading, setYbFaceButtonLoading] = useState(false)

  const [dzpzButtonLoading, setDzpzButtonLoading] = useState(false)

  const page: any = useSelector(selectPaymentPage(status))

  const storageParams = JSON.parse(sessionStorage.getItem(location.pathname) || '{}')

  const [params, setParams] = useState<PaymentListParams>({
    current: 0,
    size: 10,
    state: status,
  })

  // 公共的列表数据
  const commonListData = [
    {
      headerName: '序号',
      width: 60,
      minWidth: 60,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '门诊号',
      field: 'outpatientNo',
      width: 80,
      minWidth: 80,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'patientName',
      width: 120,
      minWidth: 120,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '病历号',
      field: 'patientId',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '结算险种',
      field: 'insuranceCode',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '读卡方式',
      field: 'cardType',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '性别',
      field: 'patientSex',
      minWidth: 80,
      visible: true,
    },
    {
      headerName: '年龄',
      field: 'patientAge',
      minWidth: 80,
      visible: true,
    },
    {
      headerName: '诊断疾病',
      field: 'disease',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '接诊科室',
      field: 'treatmentDepartmentName',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '接诊医生',
      field: 'treatmentDoctorName',
      minWidth: 110,
      visible: true,
    },
  ]

  // 待收费的列表
  const ToSettleListData: any = [
    ...commonListData,
    {
      headerName: '总金额',
      field: 'amount',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '订单来源',
      field: 'orderSource',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '收费标志',
      field: 'settlementCategory',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '挂号时间',
      field: 'registrationTime',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 120,
      minWidth: 120,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  // 已收费的列表
  const SettledListData: any = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,
      headerCheckboxSelection: true,  // 启用表头复选框（全选功能）
      width: 50,
      minWidth: 50,
      pinned: 'left',// 将列固定在左侧
      lockPosition: "left", // 锁定列位置，防止列移动
      suppressMovable: true, // 防止列被拖动
      resizable: false, //防止列宽被调整
      visible: true,
    },
    ...commonListData,
    {
      headerName: '报销金额',
      field: 'insurancePayAmount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '现金金额',
      field: 'realPayAmount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '总金额',
      field: 'amount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '应收总金额',
      field: 'shouldPayTotalAmount',
      minWidth: 120,
      visible: false,
    },
    {
      headerName: '实收总金额',
      field: 'totalRealAmount',
      minWidth: 120,
      visible: false,
    },
    {
      headerName: '应收现金金额',
      field: 'shouldPayAmount',
      minWidth: 130,
      visible: true,
    },
    {
      headerName: '优惠金额',
      field: 'discountAmount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '欠费金额',
      field: 'arrearageAmount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '收款人',
      field: 'payeeName',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '订单来源',
      field: 'orderSource',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '收费标志',
      field: 'settlementCategory',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '结算状态',
      field: 'accountingStatus',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '收费时间',
      field: 'chargeOrRefundTime',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '支付方式',
      field: 'payMethodName',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '发票类型',
      field: 'invoiceType',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '发票号',
      field: 'invoiceNo',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 180,
      minWidth: 180,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  // 已退费的列表
  const ReturnedListData: any = [
    ...commonListData,
    {
      headerName: '报销金额',
      field: 'insurancePayAmount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '现金金额',
      field: 'realPayAmount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '总金额',
      field: 'amount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '应收总金额',
      field: 'shouldPayTotalAmount',
      minWidth: 120,
      visible: false,
    },
    {
      headerName: '实收总金额',
      field: 'totalRealAmount',
      minWidth: 120,
      visible: false,
    },
    {
      headerName: '应收现金金额',
      field: 'shouldPayAmount',
      minWidth: 130,
      visible: true,
    },
    {
      headerName: '优惠金额',
      field: 'discountAmount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '欠费金额',
      field: 'arrearageAmount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '订单来源',
      field: 'orderSource',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '收费标志',
      field: 'settlementCategory',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '收费时间',
      field: 'payTime',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '退费时间',
      field: 'chargeOrRefundTime',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '支付方式',
      field: 'payMethodName',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 180,
      minWidth: 180,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = status === RecipeStatus.ToSettle ? ToSettleListData : status === RecipeStatus.Settled ? SettledListData : status === RecipeStatus.Returned ? ReturnedListData : []

  const pageName = status === RecipeStatus.ToSettle ? 'ToSettlePayment' : status === RecipeStatus.Settled ? 'SettledPayment' : 'ReturnedList'

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const [selectedKeys, setSelectedKeys] = useState<any>([])

  const [selectedTreatmentIds, setSelectedTreatmentIds] = useState<any>()

  const result = useSelector(selectResult) //预退费详情接口

  const [totalData, setTotalData] = useState<any>()

  const [totalDataSettled, setTotalDataSettled] = useState<any>()

  const [isReplaceMakeVisible, setIsReplaceMakeVisible] = useState(false)

  const [sureReplaceMakeVisible, setSureReplaceMakeVisible] = useState(false)

  const [exportLoading, setExportLoading] = useState(false)

  const [refundParams, setRefundParams] = useState<Payment>()

  const [refund, setRefund] = useState<Refund | undefined>()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const insuranceArray = useSelector(selectInsuranceArray)

  const userName = useSelector(selectUserName)

  const userId = useSelector(selectUserId)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const tenantName = useSelector(selectTenantName)

  const tenantCategory = useSelector(selectTenantCategory)

  const cycleCode = sessionStorage.getItem('cycleCode')

  const [insuranceItem, setInsuranceItem] = useState<any>()

  const baseData = useSelector(selectInsuranceItem)

  const [pageLoading, setPageLoading] = useState(false)

  const [tableDoubleFnData, setTableDoubleFnData] = useState<any>()

  const [tableId, setTableId] = useState('')

  const [loading, setLoading] = useState(false)

  const [isDetailModalVisible, setIsDetailModalVisible] = useState<any>(false)

  const [detailList, setDetailList] = useState<any>([])

  const [payAgainPayment, setPayAgainPayment] = useState<any>()

  const [payAgainLoading, setPayAgainLoading] = useState(false)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const [scrollHeight, setScrollHeight] = useState<any>()

  const submitPageList = (data: any) => {
    const params = {
      pageName: pageName,
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: pageName,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const sameFileds = allData?.find((item: any) => item?.field == v?.field)
        const resetData = data?.map((v: any) => ({
          ...v,
          minWidth: sameFileds?.minWidth || v?.minWidth,
          width: sameFileds?.width || v?.width,
          headerName: sameFileds?.headerName || v?.headerName,
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据
        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      setSelectedKeys(selectedRowKeys)
      setSelectedTreatmentIds(selectedRows?.map((v: any) => v?.treatment?.id))
    },
  }

  useEffect(() => {
    setButtonLoading(false)
    setDzpzButtonLoading(false)
    setStkButtonLoading(false)
    onResize() // 初始化设置高度
    window.addEventListener('resize', onResize)
  }, [])

  // 计算合计数据
  useEffect(() => {
    if (selectedKeys?.length) {
      // const data = page?.items?.filter((v: any) => v?.state != 5)
      const data = page?.items
      if (data?.length) {
        // 过滤出的包含勾选的所有数据
        const filterList: any = []
        selectedKeys.forEach((item: any) => {
          data.forEach((element: any) => {
            if (item == element.id) {
              filterList.push(element)
            }
          })
        })
        // 计算合计
        const insurancePayAmountAll = sum(
          filterList?.map((v: any) =>
            v?.insurancePayAmount > -1 ? Number(v?.insurancePayAmount) : 0
          )
        )

        const discountAmountAll = sum(
          data?.map((v: any) =>
            v?.discountAmount > -1 ? Number(v?.discountAmount) : 0
          )
        )

        const realPayAmountAll = sum(
          filterList?.map((v: any) =>
            v?.realPayAmount > -1 ? Number(v?.realPayAmount) : 0
          )
        )
        const amountAll = sum(
          filterList?.map((v: any) => (v?.amount > -1 ? Number(v?.amount) : 0))
        )
        const shouldPayAmountAll = sum(filterList?.map((v: any) => (v?.shouldPayAmount > -1 ? Number(v?.shouldPayAmount) : 0)))
        const totalRealAmountAll = sum(filterList?.map((v: any) => (v?.totalRealAmount > -1 ? Number(v?.totalRealAmount) : 0)))
        const shouldPayTotalAmountAll = sum(filterList?.map((v: any) => (v?.shouldPayTotalAmount > -1 ? Number(v?.shouldPayTotalAmount) : 0)))

        const qfssAmount = filterList?.map((v: any) =>
          Number(
            v?.accountingStatus == 0
              ? 0
              : (v?.realPayAmount || 0) - (v?.arrearageAmount || 0)
          )?.toFixed(2)
        )
        const qfssAmountAll = sum(qfssAmount?.map((v: any) => Number(v)))

        const arrearageAmountAll = sum(
          filterList?.map((v: any) =>
            v?.accountingStatus === 0
              ? 0
              : v?.arrearageAmount > -1
                ? Number(v?.arrearageAmount)
                : 0
          )
        )

        setTotalDataSettled({
          insurancePayAmountAll: insurancePayAmountAll,
          discountAmountAll: discountAmountAll,
          realPayAmountAll: realPayAmountAll,
          amountAll: amountAll,
          qfssAmountAll: qfssAmountAll,
          arrearageAmountAll: arrearageAmountAll,
          shouldPayAmountAll: shouldPayAmountAll,
          totalRealAmountAll: totalRealAmountAll,
          shouldPayTotalAmountAll: shouldPayTotalAmountAll,
        })
      } else {
        setTotalDataSettled({
          insurancePayAmountAll: 0.0,
          discountAmountAll: 0.0,
          realPayAmountAll: 0.0,
          amountAll: 0.0,
          qfssAmountAll: 0.0,
          arrearageAmountAll: 0.0,
          shouldPayAmountAll: 0.0,
          totalRealAmountAll: 0.0,
          shouldPayTotalAmountAll: 0.0,
        })
      }
    } else {
      const data = page?.items
      if (data?.length) {
        // 没勾选的情况下计算全部

        const insurancePayAmountAll = sum(
          data?.map((v: any) =>
            v?.insurancePayAmount > -1 ? Number(v?.insurancePayAmount) : 0
          )
        )

        const discountAmountAll = sum(
          data?.map((v: any) =>
            v?.discountAmount > -1 ? Number(v?.discountAmount) : 0
          )
        )

        const realPayAmountAll = sum(
          data?.map((v: any) =>
            v?.realPayAmount > -1 ? Number(v?.realPayAmount) : 0
          )
        )
        const amountAll = sum(
          data?.map((v: any) => (v?.amount > -1 ? Number(v?.amount) : 0))
        )
        const shouldPayAmountAll = sum(
          data?.map((v: any) => (v?.shouldPayAmount > -1 ? Number(v?.shouldPayAmount) : 0))
        )
        const shouldPayTotalAmountAll = sum(
          data?.map((v: any) => (v?.shouldPayTotalAmount > -1 ? Number(v?.shouldPayTotalAmount) : 0))
        )
        const totalRealAmountAll = sum(
          data?.map((v: any) => (v?.totalRealAmount > -1 ? Number(v?.totalRealAmount) : 0))
        )

        const qfssAmount = data?.map((v: any) =>
          Number(
            v?.accountingStatus == 0
              ? 0
              : (v?.realPayAmount || 0) - (v?.arrearageAmount || 0)
          )?.toFixed(2)
        )
        const qfssAmountAll = sum(qfssAmount?.map((v: any) => Number(v)))

        const arrearageAmountAll = sum(
          data?.map((v: any) =>
            v?.accountingStatus === 0
              ? 0
              : v?.arrearageAmount > -1
                ? Number(v?.arrearageAmount)
                : 0
          )
        )

        setTotalDataSettled({
          insurancePayAmountAll: insurancePayAmountAll,
          discountAmountAll: discountAmountAll,
          realPayAmountAll: realPayAmountAll,
          amountAll: amountAll,
          qfssAmountAll: qfssAmountAll,
          arrearageAmountAll: arrearageAmountAll,
          shouldPayAmountAll: shouldPayAmountAll,
          totalRealAmountAll: totalRealAmountAll,
          shouldPayTotalAmountAll: shouldPayTotalAmountAll,
        })
      } else {
        setTotalDataSettled({
          insurancePayAmountAll: 0.0,
          discountAmountAll: 0.0,
          realPayAmountAll: 0.0,
          amountAll: 0.0,
          qfssAmountAll: 0.0,
          arrearageAmountAll: 0.0,
          shouldPayAmountAll: 0.0,
          totalRealAmountAll: 0.0,
          shouldPayTotalAmountAll: 0.0,
        })
      }
    }
  }, [page, selectedKeys])

  // 销售单删除接口3507A
  const removeSale3507A = (
    serverType: serverType,
    paymentId: number,
    responseString?: string
  ) => {
    dispatch(
      removeSale3507AAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          paymentId
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '冲正上传',
            },
            (call: any, err) => {
              !err &&
                removeSale3507A(
                  'response',
                  paymentId,
                  JSON.stringify(call.netmessage)
                )
            }
          )
        } else {
          dispatch(cancelSaleUpload(String(paymentId)))
            .then(unwrapResult)
            .then(async (val: any) => {
              notification.success({
                message: "追溯码上传撤销成功",
              })
            })
        }
      })
  }

  const refondSubmit = (id: any) => {
    setButtonLoading(true)
    dispatch(refundPayment(id))
      .then(unwrapResult)
      .then(() => {
        notification.success({ message: '退费完成' })
        setButtonLoading(false)
        setStkButtonLoading(false)
        setDzpzButtonLoading(false)
        setRefund(undefined)
        dispatch(getPaymentList(params))
        sibling?.reload()
      })
      .catch(() => {
        setButtonLoading(false)
        setStkButtonLoading(false)
        setDzpzButtonLoading(false)
      })
  }

  useEffect(() => {
    setTotalData(page?.items?.[0])
  }, [page])

  const getPaymentListData = () => {
    dispatch(getPaymentList(params))
      .then(unwrapResult)
      .then((res: any) => {
        if (res?.items?.length) {
          onResize() // 初始化设置高度
          window.addEventListener('resize', onResize)
        }
        // if (params.param?.length == 9 && res.items.length == 1) {
        //   //获取焦点好病历号自动跳转
        //   tableDoubleFn(res.items[0])
        // }
      })
      .finally(() => setPageLoading(false))
  }
  useEffect(() => {
    if (!params?.registrationTimeHead && status != RecipeStatus.Returned || ((!params?.registrationTimeHead && params?.registration_dateRange == 6) || (!params?.refundTimeHead && params?.refund_dateRange == 6)) && status == RecipeStatus.Returned) {
      return
    }
    if (params.current !== 0) {
      setPageLoading(true)
      getPageColumnList()
      getPaymentListData()
    }
  }, [params])

  useEffect(() => {
    params.current &&
      sessionStorage.setItem(location.pathname, JSON.stringify({ selectStatus: storageParams.selectStatus, ...params }))
  }, [params, status])

  useImperativeHandle(ref, () => ({
    reload: () => {
      dispatch(getPaymentList(params))
    },
  }))

  useEffect(() => {
    if (!tableId) return
    result &&
      dispatch(getPaymentDetail(tableId))
        .then(unwrapResult)
        .then((refund) => {
          setRefund(refund)
        })
  }, [result])

  // 保存医保结构体
  useEffect(() => {
    if (insuranceItem && JSON.stringify(insuranceItem) !== '{}') {
      dispatch(
        setInsurance({
          ...insuranceItem,
          userName,
          userId,
          cycleCode,
          tenantCategory,
          tenantAreaCd,
          name: tenantName,
          address: tenantAddress,
          areaCode: tenantAreaCd,
          endTime: moment(insuranceItem.endTime).format(
            DateTimeFormatSimpleOnlyOne
          ),
        })
      )
    }
    return () => {
      dispatch(setInsurance({}))
    }
  }, [insuranceItem])

  useEffect(() => {
    if (insuranceArray.length !== 0) {
      setInsuranceItem(insuranceArray[0])
    }
  }, [insuranceArray])

  const doRefund = (cardType?: string, fullCardInfo?: string) => {
    const payMethodList = refund?.payMethod?.toString()?.split(',')
    const isJuHe: any = payMethodList?.find((v: any) => {
      return v == 2
    })
    if (isJuHe) {
      //是否聚合支付退费
      dispatch(
        JuhePremium({
          treatmentId: refund?.treatmentId?.toString() || '',
          paymentId: refund?.id || '',
        })
      )
        .then(unwrapResult)
        .then(() => {
          setButtonLoading(false)
          setStkButtonLoading(false)
          setDzpzButtonLoading(false)
          notification.success({ message: '聚合支付退费成功' })
          if (refund) {
            if (refund.insuranceCode !== 'ZIFEI') {
              cancelSettlement(
                'requestString',
                refund.id,
                cardType,
                fullCardInfo
              )
            } else {
              refondSubmit(refund.id)

              // 退费成功后，撤销追溯码3507A
              if (refund?.ybSaleUploadStatus == 1 && insuranceItem && insuranceItem?.insuranceCode == 'ZHEJIANG') {
                removeSale3507A('requestString', Number(refund?.id))
              }
            }
          }
        })
        .catch((v) => {
          setButtonLoading(false)
          setStkButtonLoading(false)
          setDzpzButtonLoading(false)
        })
    } else {
      if (refund) {
        if (refund.insuranceCode !== 'ZIFEI') {
          cancelSettlement('requestString', refund.id, cardType, fullCardInfo)
        } else {
          refondSubmit(refund.id)

          // 退费成功后，撤销追溯码3507A
          if (refund?.ybSaleUploadStatus == 1 && insuranceItem && insuranceItem?.insuranceCode == 'ZHEJIANG') {
            removeSale3507A('requestString', Number(refund.id))
          }
        }
      }
    }
  }

  const validCardInfoBeforeGoRefund = (type: string) => {
    //实体卡读卡校验
    if (type == '1') {
      setStkButtonLoading(true)
      //部分强制读卡的地区，跳过校验
      const tradeType = getTradeName()
      if (tradeType === 'CQ_ZHYB') {
        setLoading(false)
        doRefund()
        return
      }
      readCardSHttp(
        {
          trade_args: [getTradeCode(tenantAreaCd.slice(0, 4))],
        },
        (data, err) => {
          setLoading(false)
          if (!err) {
            //其他地区需要做二次读卡校验
            const Name =
              tradeType === 'JS_ZHYB'
                ? data?.netmessage
                  ?.split('|')[4]
                  ?.replace('\r', '')
                  .replace('\t', '')
                  .replace(' ', '')
                  .trim()
                : data?.netmessage?.Name
            if (Name != refund?.patientName) {
              Modal.error({
                title: '提示',
                content:
                  `退费信息与卡片信息不一致，请确认是否插错卡，就诊人：` +
                  refund?.patientName +
                  '，卡片姓名：' +
                  data?.netmessage.Name,
                okText: '确认',
              })
              setStkButtonLoading(false)
            } else {
              doRefund(type, data?.netmessage)
            }
          }
        }
      )
      //电子凭证读卡校验
    } else if (type == '2') {
      setDzpzButtonLoading(true)
      setTimeout(() => {
        setDzpzButtonLoading(false)
      }, 3000)
      readCardEHttp(
        {
          trade_args: [
            baseData?.countryHospitalNb,
            '01301',
            '',
            userId,
            userName,
            '',
            '',
          ],
        },
        (data, err) => {
          if (!err) {
            // {"netcode":"1","netmessage":"徐春霞|330621198804253802|01|330000ecaqm4mb0mvk0b8fab0a0000236f0d3c|330182|","QrCode":"","ChnlId":""}
            const readName = data?.netmessage?.split('|')[0]
            if (readName != refund?.patientName) {
              Modal.error({
                title: '提示',
                content:
                  `退费信息与卡片信息不一致，请确认是否插错卡，就诊人：` +
                  refund?.patientName +
                  '，电子凭证姓名：' +
                  readName,
                okText: '确认',
              })
              setDzpzButtonLoading(false)
            } else {
              doRefund(type, data?.netmessage)
            }
          }
        }
      )
      //自费直接调用退费
    } else if (type == '3') {
      doRefund()
      //自费直接调用退费
    } else if (type == '0') {
      doRefund()
    } else if (type == '4') {
      setYbFaceButtonLoading(true)
      setTimeout(() => {
        setYbFaceButtonLoading(false)
      }, 3000)
      readCardEHttp(
        {
          trade_args: [
            baseData?.countryHospitalNb,
            '01301',
            'cn.nhsa.ec.auth',
            userId,
            userName,
            '',
            '',
          ],
        },
        (data, err) => {
          if (!err) {
            // {"netcode":"1","netmessage":"徐春霞|330621198804253802|01|330000ecaqm4mb0mvk0b8fab0a0000236f0d3c|330182|","QrCode":"","ChnlId":""}
            const readName = data?.netmessage?.split('|')[0]
            if (readName != refund?.patientName) {
              Modal.error({
                title: '提示',
                content:
                  `退费信息与刷脸人员信息不一致，请确认是否插错卡，就诊人：` +
                  refund?.patientName +
                  '，扫脸姓名：' +
                  readName,
                okText: '确认',
              })
              setYbFaceButtonLoading(false)
            } else {
              doRefund(type, data?.netmessage)
            }
          }
        }
      )
    } else {
      Modal.error({
        title: '错误',
        content: `未知的退费类型` + type + `请联系客服人员处理`,
        okText: '确认',
      })
      //11
    }
  }

  const cancelSettlement = (
    serverType: any,
    paymentId?: string,
    cardType?: string,
    fullCardInfo?: string,
    responseString?: string
  ) => {
    const insuranceItem = insuranceArray.find(
      (v: any) => v.insuranceCode === refund?.insuranceCode
    )
    dispatch(
      cancelSettlementAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          exp_content: '',
          treatmentId: refund?.treatmentId,
          paymentId,
        },
      })
    )
      .then(unwrapResult)
      .then(async (res: any) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              notification: '退费',
            },
            (call: any, err) => {
              if (!err) {
                cancelSettlement(
                  'response',
                  paymentId,
                  cardType,
                  fullCardInfo,
                  JSON.stringify(call.netmessage)
                )
              }
              setStkButtonLoading(false)
              setDzpzButtonLoading(false)
            }
          )
        } else {
          //调用本地退费
          refondSubmit(refund?.id)

          // 退费成功后，撤销追溯码3507A （仅限浙江医保机构）
          if (refund?.ybSaleUploadStatus == 1 && insuranceItem && insuranceItem?.insuranceCode == 'ZHEJIANG') {
            removeSale3507A('requestString', Number(refund?.id))
          }

          if (cardType == '1') {
            //实体卡
            getPatientInfo(
              '3',
              baseData?.insuranceCode == 'JIANGSU'
                ? String(fullCardInfo)
                : JSON.stringify(fullCardInfo),
              'requestString'
            )
          } else if (cardType == '2') {
            //电子凭证
            getPatientInfo('1', String(fullCardInfo), 'requestString')
          }

          const data = res?.req2205 ? strParse(res?.req2205) : ''
          if (data) {
            await medicalSendHttp(
              {
                trade_args: [
                  data?.infno,
                  data?.url,
                  data,
                  insuranceItem.countryHospitalNb,
                  insuranceItem.secretToken,
                ],
                notification: '退费撤销明细',
              },
              (call: any, err) => {
                return
              }
            )
          }

          // resolve()
          // submit(vs, undefined, res)
        }
      })
      .catch((v) => {
        setStkButtonLoading(false)
        setDzpzButtonLoading(false)
      })
  }

  // 获取参保人信息
  const getPatientInfo = (
    cardType: string,
    fullCardInfo: string,
    serverType: any,
    responseString?: string
  ) => {
    dispatch(
      getPatientInfoAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          cardType: String(cardType) == "11" ? '1' : String(cardType),
          fullCardInfo,
          otherMap: {},
        },
      })
    )
      .then(unwrapResult)
      .then(async (res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call: any, err) => {
              if (!err) {
                message.loading('正在更新人员信息')
                getPatientInfo(
                  cardType,
                  fullCardInfo,
                  'response',
                  JSON.stringify(call.netmessage)
                )
                // }
              }
            }
          )
        } else {
          message.success('人员信息已更新')
        }
      })
      .catch((ex) => {
        notification.error({
          message: ex.message,
          duration: 3,
        })
      })
  }

  // 再次收费（复制收费单）
  const payAgain = (payment: any) => {
    setPayAgainPayment(payment)
  }
  // 医保自费上传
  const selfPayUpload = (
    serverType: serverType,
    treatmentId: number,
    responseString?: string
  ) => {
    dispatch(
      selfPayUploadAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          treatmentId,
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '自费上传',
            },
            (call: any, err) => {
              !err &&
                selfPayUpload(
                  'response',
                  treatmentId,
                  JSON.stringify(call.netmessage)
                )
            }
          )
        } else {
          dispatch(getPaymentList(params))
        }
      })
  }

  // 医保自费上传撤销
  const selfPayRepeal = (
    serverType: serverType,
    treatmentId: number,
    responseString?: string
  ) => {
    dispatch(
      selfPayRepealAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          treatmentId,
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '自费撤销上传',
            },
            (call: any, err) => {
              !err &&
                selfPayRepeal(
                  'response',
                  treatmentId,
                  JSON.stringify(call.netmessage)
                )
            }
          )
        } else {
          dispatch(getPaymentList(params))
        }
      })
  }

  const success = (str: string) => {
    const hide = message.loading(str, 0)
    setTimeout(() => {
      hide()
    }, 3000)
  }

  // 2204
  const FeeListUp = (
    serverType: any,
    responseString?: string,
    resolve?: any,
    reject?: any
  ) => {
    dispatch(
      FeeListUpAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          exp_content: '',
          registerFlag: 1,
          treatmentId: Number(registerData?.treatmentId),
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setUpdateFlags('1', '0')
        if (serverType === 'requestString') {
          success('正在上传费用')
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
            },
            (call, err) => {
              if (err) {
                setUpdateFlags('1', '1')
                setLoading(false)
              } else {
                setUpdateFlags('1', '0'),
                  FeeListUp('response', JSON.stringify(call.netmessage))
              }
            },
            undefined,
            reject
          )
        } else {
          messageNotification('费用上传完毕')
          registerData && preSettlement('requestString', registerData)
          resolve && resolve()
        }
      })
      .catch(() => {
        resolve && resolve()
        if (serverType === 'response') {
          setUpdateFlags('1', '1')
        }
      })
  }

  // 2205
  const FeeListUpCancel = (
    serverType: any,
    responseString?: string,
    resolve?: any,
    reject?: any
  ) => {
    dispatch(
      FeeListUpCancelAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          exp_content: '',
          chrg_bchno: '2',
          treatmentId: Number(registerData?.treatmentId),
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          success('门诊费用明细信息撤销中')
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
            },
            (call, err) => {
              if (err) {
                // setLoading(false)
              } else {
                // setUpdateFlags('2', '0')
                messageNotification('撤销成功')
                FeeListUp('requestString')
              }

              // FeeListUpCancel('response', JSON.stringify(call.netmessage))
            },
            undefined,
            reject
          )
        } else {
          FeeListUp('requestString')
          resolve && resolve()
        }
      })
      .catch(() => {
        setLoading(false)
        if (serverType === 'requestString') {
          setUpdateFlags('1', '1')
        }
        resolve && resolve()
      })
  }

  // 挂号费收取 2206
  const preSettlement = (
    serverType: serverType,
    treatmentData: registerValue,
    responseString?: string
  ) => {
    dispatch(
      preSettlementAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          chrg_bchno: '2',
          exp_content: '',
          treatmentId: treatmentData?.treatmentId,
          patientId: String(treatmentData?.patientId),
          registrationId: String(treatmentData?.registrationId),
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              // message: '正在挂号费预结算',
            },
            (call, err) => {
              !err &&
                preSettlement(
                  'response',
                  treatmentData,
                  JSON.stringify(call.netmessage)
                )
            }
          )
        } else {
          registerPayment(res)
        }
      })
  }

  const setUpdateFlags = (insuranceFlag: string, updateFlag: string) => {
    if (insuranceFlag === '1' && updateFlag === '1') {
      setLoading(false)
    }
    dispatch(
      setUpdateFlagsAsync({
        treatmentId: registerData?.treatmentId,
        insuranceFlag,
        updateFlag,
      })
    ).then(unwrapResult)
    // .then(getTreatmentsDetail)
  }

  const messageNotification = async (str: string) => {
    await message.destroy()
    notification.success({
      message: str,
      duration: 1,
    })
  }

  const doPay = (doPayparams: any, insuranceTradeId?: string) => {
    dispatch(pay({ ...doPayparams, insuranceTradeId, settlementCategory: 1 }))
      .then(unwrapResult)
      .then(() => {
        notification.success({
          message: '挂号费支付成功',
          duration: 1.5,
        })
        setIsModalVisible(false)
        dispatch(getPaymentList(params))
      })
      .catch(() => {
        setIsModalVisible(false)
      })
      .finally(() => {
        setConfirmation(undefined)
        setRegisterData(undefined)
      })
  }
  const registerPayment = (prePay?: any) => {
    setConfirmation({
      ...confirmation,
      prePay,
    } as PaymentConfirmation)

    refModal.current?.reset()
    setIsModalVisible(true)
  }

  // useEffect(() => {
  //   if (tableDoubleFnData) {
  //       tableDoubleFn(tableDoubleFnData)
  //   }
  // }, [tableDoubleFnData])

  // 表格双击跳转
  const tableDoubleFn = (record: any) => {
    if (YBZFUploadflag || LSCFSHflag) return
    if (record.settlementCategory === 1) {
      const data = {
        patient: record.treatment.patientName,
        amount: record.amount,
        // prePay,
        ids: record.recipeId,
        slots: [
          {
            name: '挂号费',
            value: record.amount,
            children: [
              {
                name: '挂号费',
                value: record.amount,
                children: [],
              },
            ],
          },
        ],
        errorMaterials: [],
      }
      const preSettlementParams: registerValue = {
        treatmentId: Number(record.treatment?.id || 0),
        patientId: Number(record.treatment?.patientId || 0),
        registrationId: Number(record.registration?.id || 0),
        recipeId: record.recipeId,
        insuranceCode: record.registration?.insuranceCode
      }
      setConfirmation(data)
      setRegisterData(preSettlementParams)
      return
    }
    if (status !== RecipeStatus.ToSettle) {
      dispatch(
        traceRoute({
          name: '收费',
          path: '/payment/result',
          query: `paymentId=${record.id}&status=${status}&selectedTab=${selectedTab}`,
          state: {
            name: status === RecipeStatus.Settled ? '已收费' : '已退费',
            path: '/payment',
            routeName: '收费',
          },
        })
      )
    } else {
      dispatch(
        traceRoute({
          name: '收费',
          path: '/payment/cart',
          query: `treatmentId=${record.treatment.id}`,
        })
      )
    }
  }
  useEffect(() => {
    if (confirmation && registerData) {
      // preSettlement('requestString', registerData)
      FeeListUpCancel('requestString', undefined, undefined, undefined)
    }
  }, [registerData])

  const outCluedExport = () => {
    setExportLoading(true)
    dispatch(getPaymentListExoprt({ ...params, size: 10000 }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '已收费.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  const getCheckHistory = (treatmentIds: any, flag: any) => {
    setAuditButtonLoading(true)
    setAuditAllButtonLoading(true)
    dispatch(
      getCheckHistoryAsync({ treatmentIds: treatmentIds ? treatmentIds : [] })
    )
      .then(unwrapResult)
      .then((v: any) => {
        if (v?.length) {
          setDetailList(v)
          setIsDetailModalVisible(true)
        } else {
          notification.success({
            message: '本次质控结果无异常',
          })
        }
      })
      .finally(() => {
        setSelectedKeys([])
        setSelectedTreatmentIds([])
        setAuditButtonLoading(false)
        setAuditAllButtonLoading(false)
      })
  }

  const onResize = () => {
    const table = document.getElementById(
      status == RecipeStatus.ToSettle
        ? 'tableHeightPaymentToSettle'
        : status == RecipeStatus.Settled
          ? 'tableHeightPaymentSettle'
          : status == RecipeStatus.Returned
            ? 'tableHeightPaymentReturned'
            : ''
    )
    if (table) {
      const height = table.offsetHeight - 60 - 80 - 20 - 40
      setScrollHeight(height)
    } else {
      return '100%'
    }
  }
  const columns =
    status === RecipeStatus.ToSettle ? PaymentColumns : PaymentColumnsWithAmount
  return (
    <Col
      style={{
        backgroundColor: theme.pn,
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 10px)',
        marginTop: '10px',
        overflow: 'hidden',
        padding: '20px 15px',
      }}
    >
      <PaymentQuery
        loading={pageLoading}
        filterColumn={allColumnList}
        filterSelectList={filterSelectList}
        submitPageList={((v: any) => {
          setPageLoading(true)
          submitPageList(v)
          setAllColumnList(v)
        })}
        outExportExcel={() => {
          dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.SFDCDYQX }))
            .then(unwrapResult)
            .then((res: any) => {
              outCluedExport()
            })
        }}
        exportLoading={exportLoading}
        auditButtonLoading={auditAllButtonLoading}
        audit={() => {
          if (!selectedKeys?.length) {
            notification.info({
              message: '请选择要审核的数据',
            })
          } else {
            getCheckHistory(selectedTreatmentIds, false)
          }
        }}
        onValueChange={(v) => {
          setSelectedKeys([])
          setSelectedTreatmentIds([])
          if (selectedTab == '0' || selectedTab == '1' || selectedTab == '2') {
            setParams({
              ...params,
              ...v,
              actionTimeHead: null,
              actionTimeTail: null,
              payMethod: null,
            })
          } else {
            setParams({ ...params, ...v })
          }
        }}
        status={status}
        selectedTab={selectedTab}
        YBZFUploadflag={YBZFUploadflag}
        LSCFSHflag={LSCFSHflag}
      />
      <div
        id={
          status == RecipeStatus.ToSettle
            ? 'tableHeightPaymentToSettle'
            : status == RecipeStatus.Settled
              ? 'tableHeightPaymentSettle'
              : status == RecipeStatus.Returned
                ? 'tableHeightPaymentReturned'
                : ''
        }
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        <SimpleAgGrid
          // rowHeight={67}
          page={page}
          column={AGColumns(
            status,
            page?.size * (page?.current - 1),
            (action, id, t, settlementCategory) => {
              switch (action) {
                case 'pay':
                  if (settlementCategory === 1) {
                    // return
                    const data = {
                      patient: t.treatment.patientName,
                      amount: t.amount,
                      // prePay,
                      ids: t.recipeId,
                      slots: [
                        {
                          name: '挂号费',
                          value: t.amount,
                          children: [
                            {
                              name: '挂号费',
                              value: t.amount,
                              children: [],
                            },
                          ],
                        },
                      ],
                      errorMaterials: [],
                    }
                    const preSettlementParams = {
                      treatmentId: t.treatment?.id,
                      patientId: t.treatment?.patientId,
                      registrationId: t.registration?.id,
                      recipeId: t.recipeId,
                      insuranceCode: t.registration?.insuranceCode
                    }
                    setConfirmation(data)
                    setRegisterData(preSettlementParams)
                  } else {
                    dispatch(
                      traceRoute({
                        name: '收费',
                        path: '/payment/cart',
                        query: `treatmentId=${id}&phone=${t.registration.patientPhone}`,
                      })
                    )
                  }
                  break
                case 'return':
                  setTableId(t?.id)
                  if (t.potionRecipeStatus !== 1) {
                    dispatch(getPaymentResult(t?.id)) //获取预退费表格信息
                  } else {
                    setIsReplaceMakeVisible(true)

                    setRefundParams(t)
                  }
                  break
                case 'detail':
                  dispatch(
                    traceRoute({
                      name: '收费',
                      path: '/payment/result',
                      query: `paymentId=${id}&status=${status}&selectedTab=${selectedTab}`,
                      state: {
                        name:
                          status === RecipeStatus.Settled ? '已收费' : '已退费',
                        path: '/payment',
                        routeName: '收费',
                      },
                    })
                  )
                  break
                case 'upload':
                  selfPayUpload('requestString', t.treatment.id)
                  break
                case 'repeal':
                  selfPayRepeal('requestString', t.treatment.id)
                  break
                case 'supplementary':
                  dispatch(
                    traceRoute({
                      name: '补交',
                      path: '/payment/oweMoney',
                      query: `paymentId=${id}`,
                    })
                  )
                  break
                case 'payAgain':
                  payAgain(t)
                  break
                case 'check':
                  getCheckHistory([t?.treatment?.id], true)
                  break
              }
            },
            YBZFUploadflag,
            LSCFSHflag,
            auditButtonLoading,
            allColumnList,
            totalDataSettled?.arrearageAmountAll?.toFixed(2)
          )?.filter((item: any) => filterSelectList?.includes(item.field))}
          isLoading={pageLoading}
          pagination={true}
          pageKey={'payments'}
          rowSelection="multiple"
          selectedRowKeys={selectedKeys || []}
          getRowId={(data: any) => data?.id?.toString()}
          onRowDoubleClick={(event: any) => {
            tableDoubleFn(event.data)
          }}
          onSelectionChange={(selectedRows: any, selectedNodes: any) => {
            setSelectedKeys(selectedRows?.map((row: any) => row?.id))
          }}
          suppressRowClickSelection={true}
          // 配置底部行样式
          getRowStyle={(params) => {
            if (params.node.rowPinned) {
              return {
                fontWeight: 'normal',
                backgroundColor: '#D9F2FF',
              };
            }
            return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
          }}
          onChangePage={(current, size) => {
            setSelectedKeys([])
            setParams({
              ...params,
              current,
              size,
            })
          }}
          onColumnResized={(v) => {
            return
          }}
          onColumnMoved={(v) => {
            // setPageLoading(true)
            const sortList = getSortColumnList(allColumnList, v);
            submitPageList(sortList)
            setAllColumnList(sortList)
          }}
          pinnedBottomRowData={[{
            insurancePayAmount: (
              status === RecipeStatus.Settled
                ? totalDataSettled?.insurancePayAmountAll?.toFixed(2)
                : status === RecipeStatus.Returned
                  ? totalData?.totalReimbursementAmount?.toFixed(2) : ''
            ) || '0.00',
            realPayAmount: (status === RecipeStatus.Settled
              ? totalDataSettled?.realPayAmountAll?.toFixed(2)
              : status === RecipeStatus.Returned ?
                totalData?.totalRealPayAmount?.toFixed(2) : ''
            ) || '0.00',
            amount: (status === RecipeStatus.Settled
              ? totalDataSettled?.amountAll?.toFixed(2)
              : totalData?.totalPrice?.toFixed(2) 
            ) || '0.00',
            shouldPayTotalAmount: (status === RecipeStatus.Settled ? totalDataSettled?.shouldPayTotalAmountAll?.toFixed(2) : totalData?.totalShouldPayTotalAmount?.toFixed(2)) || '0.00',
            totalRealAmount: (status === RecipeStatus.Settled ? totalDataSettled?.totalRealAmountAll?.toFixed(2) : totalData?.totalRealPayAmount?.toFixed(2)) || '0.00',
            shouldPayAmount: (status === RecipeStatus.Settled ? totalDataSettled?.shouldPayAmountAll?.toFixed(2) : totalData?.totalShouldPayAmount?.toFixed(2)) || '0.00',
            discountAmount: (status === RecipeStatus.Settled ? totalDataSettled?.discountAmountAll?.toFixed(2) : totalData?.totalDiscountAmount?.toFixed(2)) || '0.00',
            arrearageAmount: (status === RecipeStatus.Settled ? totalDataSettled?.arrearageAmountAll?.toFixed(2) : ''),
          }]}
        />
      </div>

      {/* </div> */}
      {/* 挂号费收取弹窗 */}
      <Modal
        title='预收挂号费'
        width={1100}
        cancelText='取消'
        okText='确认'
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
          setUpdateFlags('0', '0')
        }}
        onOk={() => {
          refModal.current?.submit()
        }}
        bodyStyle={{ padding: 0 }}
      >
        <PaymentConfirm
          ref={refModal}
          confirmation={confirmation}
          YUSHOUGUAHAOFEI={true}
          YUSHOUtreatment={registerData}
          isPayPage={true}
          onPay={(callParams) => {
            setUpdateFlags('0', '0')
            if (callParams.success == '1') {
              notification.success({
                message: '挂号费支付成功',
                duration: 1.5,
              })
              setIsModalVisible(false)
              dispatch(getPaymentList(params))
            } else {
              setIsModalVisible(false)
            }
            setConfirmation(undefined)
            setRegisterData(undefined)
          }}
        />
      </Modal>
      {/* 预退费弹窗 */}
      <RealPayModal
        buttonLoading={buttonLoading}
        stkButtonLoading={stkButtonLoading}
        dzpzButtonLoading={dzpzButtonLoading}
        ybFaceButtonLoading={ybFaceButtonLoading}
        refund={refund}
        onOK={(type) => {
          validCardInfoBeforeGoRefund(type)
        }}
        onCancel={() => setRefund(undefined)}
        resultData={result?.paymentDetailRecordVOS}
      />

      <Modal
        closable={false}
        maskClosable={false}
        cancelText='不撤销'
        okText='撤销'
        visible={isReplaceMakeVisible}
        title=''
        onOk={() => {
          setIsReplaceMakeVisible(false)
          dispatch(
            isCancelUpload({
              treatmentId: refundParams!.registration.treatmentId,
              potionRecipeStatus: 3,
              paymentId: refundParams!.id,
            })
          )
            .then(unwrapResult)
            .then(() => {
              dispatch(getPaymentDetail(refundParams!.id))
                .then(unwrapResult)
                .then((refund) => {
                  // setRefund(refund)
                  dispatch(getPaymentResult(tableId)) //获取预退费表格信息
                })
            })
        }}
        onCancel={() => {
          setIsReplaceMakeVisible(false)
          setSureReplaceMakeVisible(true)
        }}
      >
        本单已传至代煎方，需要撤销代煎吗？
      </Modal>
      {/* <Modal
        title='复制收费单'
        visible={!!payAgainPayment}
        onCancel={() => {
          setPayAgainPayment(undefined)
          setPayAgainLoading(false)
        }}
        confirmLoading={payAgainLoading}
        onOk={() => {
          setPayAgainLoading(true)
          if (payAgainPayment?.id) {
            dispatch(payAgainAsync({ paymentId: payAgainPayment?.id }))
              .then(unwrapResult)
              .then((res: any) => {
                if (hisVersion == 1) {
                  notification.success({
                    message: '复制完成，请到待收费页面查看新的单据。',
                  })
                } else {
                  Modal.confirm({
                    centered: true,
                    title: '复制完成',
                    width: 320,
                    content: <div>是否跳转到新的病历处方页？</div>,
                    okText: '确认',
                    cancelText: '取消',
                    icon: null,
                    onOk: () => {
                      setPayAgainPayment(undefined)
                      dispatch(
                        traceRoute({
                          name: '医生门诊',
                          path: '/treatment',
                          query: `registrationId=${res}`,
                          state: {
                            backSelectTab: 'editor',
                          },
                        })
                      )
                    },
                    onCancel: () => {
                      setPayAgainPayment(undefined)
                    },
                  })
                }
              })
              .finally(() => setPayAgainLoading(false))
          }
        }}
      >
        <div>
          {payAgainPayment?.paymentInsuranceCode != 'ZIFEI' ? (
            <div>
              <p>
                系统会自动复制一条
                <span style={{ color: '#2772d2', fontWeight: 'bold' }}>
                  自费
                </span>
                的待收费记录，您可以修改该处方后重新结算。
              </p>
              <p>
                若您仍想以医保结算，请在复制后使用
                <span style={{ color: '#2772d2', fontWeight: 'bold' }}>
                  自费转医保（需重新读卡）
                </span>
                功能。
              </p>
            </div>
          ) : (
            <p>
              系统会自动复制一条新的待收费记录，您可以修改该处方后重新发起结算。
            </p>
          )}

          <p>是否继续？</p>
        </div>
      </Modal> */}
      <ChargeAgainModal
        payAgainPayment={payAgainPayment}
        visible={!!payAgainPayment}
        onCancel={() => {
          setPayAgainPayment(undefined)
          // setPayAgainLoading(false)
        }}
        onOk={(() => {
          setPayAgainPayment(undefined)
          // setPayAgainLoading(false)
        })}
      // confirmLoading={payAgainLoading}
      ></ChargeAgainModal>
      <Modal
        visible={sureReplaceMakeVisible}
        title=''
        onOk={() => {
          setSureReplaceMakeVisible(false)
          dispatch(getPaymentDetail(refundParams!.id))
            .then(unwrapResult)
            .then((refund) => {
              // setRefund(refund)
              dispatch(getPaymentResult(tableId)) //获取预退费表格信息
            })
        }}
        onCancel={() => {
          setSureReplaceMakeVisible(false)
        }}
      >
        退费时不撤销订单可能带来损失，确认不需要撤销代煎吗？
      </Modal>
      <DetailModalList
        visible={isDetailModalVisible}
        detailList={detailList}
        onOk={() => {
          setIsDetailModalVisible(false)
        }}
        onCancel={() => {
          setIsDetailModalVisible(false)
        }}
      ></DetailModalList>
    </Col>
  )
}

export const Payments = forwardRef(RealPayments)
